<template>
  <!-- <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + this.tournImage + ')' }"> -->
  <div>
        <div class="Btours" v-bind:style="{ 'background-image': 'url(' + slideshow[0].mobile_image + ')' }">
            <div class="outerDiv">
                <div class="innerDiv">
                    <h1 class="heading" :style="'color:' + slideshow[0].slide_heading_color">{{slideshow[0].slide_heading}}</h1>
                    <p class="line1" v-html="slideshow[0].slide_text_line_1_mobile"></p>
                    <p class="line2" v-html="slideshow[0].slide_text_line_2_mobile"></p>
                    <p class="line3" v-html="slideshow[0].slide_text_line_3_mobile"></p>
                </div>
            </div>
        </div>

  </div>
</template> 

<script>
import apiCall from "@/services/api.js";
import 'vueperslides/dist/vueperslides.css'
export default {
  name: "Just Slides",
  components: {
  },
  props:[
    'frontImage',
    'backImage'
  ],
  data() {
    return {
        slideshow: [],
    }
  },
  created() {
    const json = "wp/v2/slideshow?randomadd=" +
            new Date().getTime();
    apiCall
      .wpInfo(json)
      .then(({ data }) => {
        this.slideshow = data[0].acf.slideshow;
        console.log( "this.slideshow")
        console.log( this.slideshow)
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::v-deep .vueperslide {
    white-space: normal;
    background-size: cover;
    flex-shrink: 0;
    display: block;
    width: 100%;
    position: relative;
    will-change: transform;
}
h1.heading {
    text-transform: uppercase;
    font-size: 70px;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
}
p.line1 {
    /* text-transform: uppercase; */
    font-size: 40px;
}
p.line2 {
    /* text-transform: uppercase; */
    font-size: 20px;
}
p.line3 {
    /* text-transform: uppercase; */
    font-size: 10px;
}
.innerDiv {
    position: absolute;
    top: 30%;
    color: #fff;
    z-index: 999;
    /* height: 200px; */
    width: 100%;
    background-color: rgba(8, 28, 63, 0.5);
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30px;
}
::v-deep .vueperslides__parallax-wrapper {
  height: 750px!important;
}
.tableHome {
  padding-bottom: 2%;
  background-repeat: no-repeat;
  /* height: 700px; */
  height: 100%!important;
  background-size: cover;
  /* margin-bottom: 4em; */
  background-position: center;
}
.Btours {
    height: 750px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
@media only screen and (min-width: 991px) {
    ::v-deep .below990 {
        display: none;
    }
}
@media only screen and (max-width: 990px) {
    ::v-deep .above990 {
        display: none;
    }
}
@media only screen and (max-width: 1366px) {
    h1.heading {
        text-transform: uppercase;
        font-size: 50px;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
    }
    p.line1 {
        /* text-transform: uppercase; */
        font-size: 20px;
    }
    p.line2 {
        /* text-transform: uppercase; */
        font-size: 15px;
    }
    p.line3 {
        /* text-transform: uppercase; */
        font-size: 10px;
    }
}
@media only screen and (max-width: 510px) {
    ::v-deep .vueperslides__parallax-wrapper {
        /* height: 100%!important; */
        /* height: 425px!important; */
    }
    p.line2 {
        display: none;
    }
    p.lin3 {
        display: none;
    }
}
@media only screen and (max-width: 375px) {
    ::v-deep .vueperslides__parallax-wrapper {
        /* height: 100%!important; */
        /* height: 375px!important; */
    }
    p.line2 {
        display: none;
    }
    p.lin3 {
        display: none;
    }
    .innerDiv {
        position: absolute;
        top: 30%;
        color: #fff;
        z-index: 999;
        /* height: 200px; */
        width: 100%;
        background-color: rgba(8, 28, 63, 0.5);
        text-align: center;
        padding-top: 30px;
        padding-bottom: 30px;
    }
}
</style>
